<template lang="pug">
.name.text-center.d-flex.align-items-center.justify-content-center
  strong(v-if='!editingName', @click='toggleNameEdit()') {{ sprite.name }}
  input(v-if='editingName', type='text', v-model='newName', @keyup.enter='toggleNameEdit()')
  button.save-button(v-if='editingName', @click='toggleNameEdit()') Save
  .edit-button(v-else, @click='toggleNameEdit()')
    svg(xmlns='http://www.w3.org/2000/svg', width='16', height='16', viewbox='0 0 16 16')
      path(fill-rule='evenodd', d='M12.804 0l-1.506 1.507 3.195 3.195L16 3.196 12.804 0zM0 12.805V16h3.196L13.364 5.832l-3.196-3.196L0 12.805z')
</template>

<style lang="scss" scoped>
  .name {
    strong {
      margin-left: 1.2rem;
      height: 32px;
      font-size: 24px;
      font-weight: bold;
      font-style: normal;
      line-height: 1.33;
      letter-spacing: normal;
      text-align: center;
      color: #363734;
    }

    .edit-button {
      opacity: 0;
      margin-left: 1.143em;

      svg {
        fill: #A1A39E;
      }
    }

    .edit-button:hover {
      cursor: pointer;

      svg:hover {
        fill: #6C6D69;
      }
    }

    .save-button {
      background: none;
      border: none;
      font-size: 12px;
      font-weight: bold;
      margin-left: -2.2rem;
      color: #3BA5A8;
      z-index: 1;
    }

    .save-button:hover {
      cursor: pointer;
    }

    input {
      background: none;
      border: none;
      border-bottom: 1px dashed #A1A39E;
      font-size: 24px;
      font-weight: normal;
      color: #6C6D69;
    }

    input:focus {
      outline: none;
    }
  }

  .name:hover .edit-button {
    opacity: 1;
  }
</style>

<script>
import axios from 'axios';

export default {
  props: ['sprite'],
  data() {
    return {
      editingName: false,
      newName: '',
    };
  },
  mounted() {
    this.newName = this.sprite.name;
  },
  methods: {
    toggleNameEdit() {
      this.editingName = !this.editingName;

      if (this.editingName || this.newName === this.sprite.name) return;

      if (this.newName.length > 25) {
        alert('The name must be under 25 characters.');
        return;
      }

      // @TODO: Move to action
      axios.post(`/sprites/${this.sprite._id}/rename`, { name: this.newName });

      // @TODO: Move to mutation
      if (this.$store.state.favoriteMonster._id === this.sprite._id) {
        this.$store.state.favoriteMonster.name = this.sprite.name;
      }
      this.sprite.name = this.newName;

      const spriteToUpdate = this.$store.state.usersMonsters.find(sprite => sprite._id === this.sprite._id);
      spriteToUpdate.name = this.newName;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/monsters/SpriteNameDisplay.vue